<template>
    <div class="col backgroundForm">
      <div class="col col-md-10 offset-md-1">
              <div class="col col-md-6 offset-md-3">
                  <div class="alert alert-danger" role="alert">
                      <h4 class="alert-heading">Asignación, Registro y Seguimiento de Tareas</h4>        
                      <hr>
                      <p>Tablero de Tareas</p>
                  </div>
              </div>
          </div>
      <nav>
          <div class="nav nav-pills" id="nav-tab" role="tablist">
              
              <a class="nav-item nav-link active" id="nav-second-traffic" data-toggle="tab" href="#reg-tarea" role="tab" aria-controls="nav-profile" aria-selected="false">Asignación de Tareas</a>
              <a class="nav-item nav-link" id="nav-init-traffic" data-toggle="tab" href="#baja-tarea" role="tab" aria-controls="nav-home" aria-selected="true">Inhabilitacion de tareas</a>
              
              <a class="nav-item nav-link" id="nav-init-traffic" data-toggle="tab" href="#control-tarea" role="tab" aria-controls="nav-home" aria-selected="true">Control de Tareas</a>
  
          </div>
      </nav>
  
      <div class="tab-content" id="nav-tabContent">
          <br>            
      
          <div class="tab-pane fade show active"  id="reg-tarea" role="tabpanel" aria-labelledby="nav-home-tab" >
              <!-- tab 1 -->
              <div class="form-row">
                  <div class="form-group col-12 col-md-4">
                      <label for="ordop_title">División Origen <span class="required-text">*</span></label>
                      <select name="origen_task" id="origen_task" class="form-control" v-model="dts_tarea.origen">
                        <option v-for="lo in list_divisiones" :key="lo.id" :value="lo.id">{{ lo.detail }}</option>
                      </select>
                  </div>
                  <div class="form-group col-12 col-md-4">
                      <label for="type_ordop">Tipo Documento <span class="required-text">*</span></label>
                      <select name="origen_task" id="origen_task" class="form-control" v-model="dts_tarea.tipodoc">
                        <option v-for="tl in list_tareas" :key="tl.id" :value="tl.id">{{ tl.detail }}</option>
                      </select>
                  </div>
                  <div class="form-group col-12 col-md-4">
                      <label for="type_ordop">Trazado <span class="required-text">*</span></label>
                      <input type="text" class="form-control" id="ordop_title" placeholder="DGCP/DIV/MN XX/XX"  autocomplete="off" v-model="dts_tarea.ruta">
                  </div>                  
              </div>

              <div class="form-row">
                  <div class="form-group col-12">
                      <label for="ordop_title">Resumen Tarea <span class="required-text">*</span></label>
                      <input type="text" class="form-control" id="ordop_title" placeholder="INFORMAR RESPECTO A TAREAS ASIGNADAS" autocomplete="off" v-model="dts_tarea.resumen">
                  </div>
              </div>

              <div class="form-row">
                <div class="form-group col-12 col-md-6">
                      <label for="type_ordop">Fecha Emisión<span class="required-text">*</span></label>
                      <input type="date" class="form-control" id="ordop_title" placeholder="CP. MY."  autocomplete="off" v-model="dts_tarea.inicio">
                  </div>
                  <div class="form-group col-12 col-md-6">
                      <label for="type_ordop">Fecha Vencimiento<span class="required-text">*</span></label>
                      <input type="date" class="form-control" id="ordop_title" placeholder="CP. MY."  autocomplete="off" v-model="dts_tarea.vencimiento">
                  </div>
              </div>

                <div class="form-group">
                    <label for="fileArchivoMensaje">Mensaje o Documento</label>
                    <input type="file" class="form-control-file" id="fileArchivoMensaje" @change="handleFileUpload" accept=".pdf">
                </div>

                <button class="btn btn-success col-12 col-md-4 offset-md-4" @click="mRegisterTarea" :disabled="animacion_file">
                    <font-awesome-icon icon="save"  size="2x" :spin="animacion_file" /> Registrar
                </button>
          </div>
          
          <!-- final tab 1 -->

          <div class="tab-pane fade" id="baja-tarea" role="tabpanel" aria-labelledby="nav-home-tab">
              <h6>Baja o Inhabilitación Tareas</h6>
              <hr>

              <div class="form-row">

                <div class="form-group col-12 col-md-4">
                      <label for="ordop_title">División Origen <span class="required-text">*</span></label>
                      <select name="origen_task" id="origen_task" class="form-control" v-model="dts_asignados.origen">
                        <option v-for="lo in list_divisiones" :key="lo.id" :value="lo.id">{{ lo.detail }}</option>
                      </select>
                  </div>

                <div class="form-group col-12 col-md-4">
                      <label for="type_ordop">Fecha Inicio<span class="required-text">*</span></label>
                      <input type="date" class="form-control" id="ordop_title" placeholder="CP. MY."  autocomplete="off" v-model="dts_asignados.inicio">
                  </div>
                  <div class="form-group col-12 col-md-4">
                      <label for="type_ordop">Fecha Final<span class="required-text">*</span></label>
                      <input type="date" class="form-control" id="ordop_title" placeholder="CP. MY."  autocomplete="off" v-model="dts_asignados.final">
                  </div>
              </div>

              <button class="btn btn-success col-12 col-md-4 offset-md-4" @click="mCallTasks">
                  <font-awesome-icon icon="list"  size="2x" /> Listar
              </button>

              <div class="table-responsive" v-if="lists_tasks_register.length>0">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Origen</th>
                            <th>Tipo Documento</th>
                            <th>Ruta</th>
                            <th>Dias Restantes</th>
                            <th>Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(tr,index) in lists_tasks_register" :key="tr.id" :class="tr.visible==='S' ? 'alert alert-success': 'alert alert-danger'">
                            <td>{{ (index+1) }}</td>
                            <td>{{ tr.origen }}</td>
                            <td>{{ tr.tipodoc }}</td>
                            <td>{{ tr.ruta }}</td>
                            <td>{{ tr.dias_resto }} días faltantes</td>
                            <td>
                                <span v-if="tr.visible==='S'">
                                    <button class="btn btn-success" @click="mChangeVisible(tr.id_task, 'D')"><font-awesome-icon icon="arrow-circle-up" /></button></span>
                                <span v-else><button class="btn btn-danger" @click="mChangeVisible(tr.id_task, 'U')"><font-awesome-icon icon="arrow-circle-down" /></button></span>
                            </td>
                        </tr>
                    </tbody>
                </table>
              </div>
              
          </div>
  
          <!-- aqui va de las uu o capitanias de puerto -->
          <div class="tab-pane fade"  id="control-tarea" role="tabpanel" aria-labelledby="nav-home-tab" >
              <!-- tab 1 -->
                <h5>Apoya en el control de que Unidades realizaron el trabajo Asignado</h5>
            <div v-if="task_select.id_task===0">
                <div class="form-row">
                <div class="form-group col-12 col-md-4">
                    <label for="ordop_title">División Origen <span class="required-text">*</span></label>
                    <select name="origen_task" id="origen_task" class="form-control" v-model="dts_control.origen">
                        <option v-for="lo in list_divisiones" :key="lo.id" :value="lo.id">{{ lo.detail }}</option>
                    </select>
                </div>

                <div class="form-group col-12 col-md-4">
                    <label for="type_ordop">Fecha Inicio<span class="required-text">*</span></label>
                    <input type="date" class="form-control" id="ordop_title" placeholder="CP. MY."  autocomplete="off" v-model="dts_control.inicio">
                </div>
                <div class="form-group col-12 col-md-4">
                    <label for="type_ordop">Fecha Final<span class="required-text">*</span></label>
                    <input type="date" class="form-control" id="ordop_title" placeholder="CP. MY."  autocomplete="off" v-model="dts_control.final">
                </div>
                </div>

                <button class="btn btn-success col-12 col-md-4 offset-md-4" @click="mCallTasksControl">
                <font-awesome-icon icon="list"  size="2x" /> Listar
                </button>

                <div class="table-responsive" v-if="lists_tasks_control.length>0">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Origen</th>
                            <th>Tipo Documento</th>
                            <th>Ruta</th>
                            <th>Dias Restantes</th>
                            <th>Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(tr,index) in lists_tasks_control" :key="tr.id" :class="tr.visible==='S' ? 'alert alert-success': 'alert alert-danger'">
                            <td>{{ (index+1) }}</td>
                            <td>{{ tr.origen }}</td>
                            <td>{{ tr.tipodoc }}</td>
                            <td>{{ tr.ruta }}</td>
                            <td>{{ tr.dias_resto }} días faltantes</td>
                            <td>
                                <button class="btn btn-success" @click="mSelectTask(tr)"><font-awesome-icon icon="check" /></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                </div>           
            </div>
            <div v-else>
                <div class="alert alert-success">{{ task_select.tipodoc }} {{ task_select.ruta }} <button type="button" class="close" aria-label="Close" @click="mClearTask">
                <span aria-hidden="true">&times;</span>
                </button>
                </div>
                <div class="input-group input-group-lg col-12 col-md-6 offset-md-3">
                    <select name="" id="" class="form-control" v-model="unit_select_approve">
                        <option v-for="lu in list_unidades" :key="lu.id_capitania" :value="lu.id_capitania">{{ lu.type_short }} {{ lu.name_port }}</option>
                    </select>
                    <div class="input-group-prepend">
                    <button class="btn btn-success" @click="mApprovTask"><font-awesome-icon icon="check" /></button>
                    </div>
                </div>

                <br><br>
                <button class="btn btn-warning col-12 col-md-4 offset-md-4" @click="mListaCumplidos">Mostrar Cumplimiento <font-awesome-icon icon="list" /></button>

                <br><br>
                    <button class="col col-md-2 offset-md-5 btn btn-info" @click="mCopyToClipboard(table_res_cump)" v-if="list_unidades_cumplimiento.length>0"> <font-awesome-icon icon="copy" size="lg" /> Copiar</button>
                    <br><br>
                <div class="table-responsive" :id="table_res_cump" v-if="list_unidades_cumplimiento.length>0">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th colspan="3">{{ task_select.tipodoc }} {{ task_select.ruta }}</th>
                            </tr>
                            <tr>
                                <th>#</th>
                                <th>Unidad</th>
                                <th>Cumplimiento</th>
                                <!-- <th>Anular</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(tr,index) in list_unidades_cumplimiento" :key="tr.id" :class="tr.cumplimiento==='S' ? 'alert alert-success': 'alert alert-danger'">
                                <td>{{ (index+1) }}</td>
                                <td>{{ tr.nombre_unidad }}</td>
                                <td>{{ tr.cumplimiento==='S' ? 'SI CUMPLIO': 'NO CUMPLIO' }}</td>
                                <!-- <td>
                                    <button class="btn btn-success" @click="mSelectTask(tr)"><font-awesome-icon icon="minus-circle" /></button>
                                </td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>


            </div>
          </div>
          <!-- end tab control tareas -->
  
      </div>
    </div>
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from 'axios'
  const qs= require('qs');
  export default {
      data(){
          return{
            table_res_cump:'id_table_cumplimiento',
            dts_tarea:{
                origen:0,
                tipodoc:0,
                ruta:'',
                resumen:'',
                inicio:'',
                vencimiento:''
            },
            select_file:null,
            list_tareas:[],
            list_divisiones:[],
            animacion_file:false,
            dts_asignados:{
                origen:0,
                inicio:'',
                final:''
            },
            dts_control:{
                origen:0,
                inicio:'',
                final:''
            },
            lists_tasks_register:[],
            lists_tasks_control:[],
            task_select:{
                id_task:0
            },
            list_unidades:[],
            list_unidades_register_cump:[],
            list_unidades_cumplimiento:[],
            unit_select_approve:0
          }
      },
      mounted(){
          this.mChargeInit();
      },
      methods:{
        mCopyToClipboard(elemento){
            var $temp = $("<input>")
            $("body").append($temp);
            // console.log($(`#${elemento}`));
            $temp.val($(`#${elemento}`).html()).select();
            document.execCommand("copy");
            $temp.remove();
            toastr.info('Tabla copiada con exito', 'Archivo copiado')
        },
        mObtieneDiaActual(){
            let nday=new Date();
            let dia=nday.getDate()<10 ? `0${nday.getDate()}`:nday.getDate();
            let mes =(nday.getMonth())+1<10 ? `0${(nday.getMonth()+1)}`:(nday.getMonth()+1);
            let ndiaenvio= `${nday.getFullYear()}-${mes}-${dia}`;
            return ndiaenvio;
        },
        mMostrarCumplidos(){
            this.list_unidades_cumplimiento=[];
            // this.mListaCumplidos();
            // console.log(this.list_unidades_register_cump);
            this.list_unidades.forEach(du=>{
                let auxBus=this.list_unidades_register_cump.findIndex(dt=>dt.id_unidad===du.id_capitania);
                if(auxBus>=0){
                    let aux_cump={
                        id_unidad:du.id_capitania,
                        nombre_unidad:`${du.type_short} ${du.name_port}`,
                        cumplimiento:'S'
                    }
                    this.list_unidades_cumplimiento.push(aux_cump);
                }else{
                    let aux_cump={
                        id_unidad:du.id_capitania,
                        nombre_unidad:`${du.type_short} ${du.name_port}`,
                        cumplimiento:'N'
                    }
                    this.list_unidades_cumplimiento.push(aux_cump);
                }
            })
        },
        async mApprovTask(){
            if(this.unit_select_approve>0){

                let aux_cum={
                    id_task:this.task_select.id_task,
                    id_unidad:this.unit_select_approve
                }
                let tasks_approbe= await axios.post(`approveCumplimiento?api_token=${Vue.auth.getToken()}`, qs.stringify(aux_cum));
                if(tasks_approbe.data.status){
                    toastr.success(`${tasks_approbe.data.response}`)
                    setTimeout(()=>{
                        this.mListaCumplidos();
                    }, 2000)
                }
            }else{
                toastr.warning('Seleccione una Unidad a Aprobar');
            }
                // console.log(tasks);
                // this.lists_tasks_register=tasks.data;
        },
        async mListaCumplidos(){
            let listCump=await axios.get(`getCumplidosTask/${this.task_select.id_task}?api_token=${Vue.auth.getToken()}`)
            this.list_unidades_register_cump=listCump.data;
            this.mMostrarCumplidos();
        },
        async mIncumplimiento(idCaptain){

        },
        mClearTask(){
            this.task_select.id_task=0;
            this.list_unidades_cumplimiento=[];
        },
        mSelectTask(ts){
            // console.log(ts);
            let aux={
                id_task:ts.id_task,
                tipodoc:ts.tipodoc,
                ruta:ts.ruta,
                origen:ts.origen,
                resume:ts.resume,
                fecha_emision:ts.fecha_emision,
                fecha_conclusion:ts.fecha_conclusion,
                visible:ts.visible
            }
            // este metodo selecciona la tarea para realizar la asignacion de quienes cumplieron las tarea como tal
            this.task_select=aux;
        },
        async mChangeVisible(id, type){
            let update_visible=await axios.get(`updateTask/${id}/${type}?api_token=${Vue.auth.getToken()}`);
            // console.log(update_visible)
            toastr.success('Se ha actualizado exitosamente')
            this.mCallTasks();
        },
        mValidateCallTasks(){
            if(this.dts_asignados.origen===0){
                toastr.warning(`Seleccione una unidad de Origen`);
                return false;
            }

            if(this.dts_asignados.inicio===''){
                toastr.warning(`Indique una fecha de inicio de Busqueda`);
                return false;
            }

            if(this.dts_asignados.final===''){
                toastr.warning(`Indique una fecha final de Busqueda`);
                return false;
            }

            if(this.dts_asignados.final<this.dts_asignados.inicio){
                toastr.warning(`La fecha de Inicio <b>NO</b> puede ser Mayor a la final`);
                return false;
            }
            return true;
        },
        async mCallTasks(){ 
            if(this.mValidateCallTasks()){
                let tasks= await axios.post(`getTasksCaptainsAll?api_token=${Vue.auth.getToken()}`, qs.stringify(this.dts_asignados));
                // console.log(tasks);
                this.lists_tasks_register=tasks.data;
            }
        },
        mValidateCallTasksControl(){
            if(this.dts_control.origen===0){
                toastr.warning(`Seleccione una unidad de Origen`);
                return false;
            }

            if(this.dts_control.inicio===''){
                toastr.warning(`Indique una fecha de inicio de Busqueda`);
                return false;
            }

            if(this.dts_control.final===''){
                toastr.warning(`Indique una fecha final de Busqueda`);
                return false;
            }

            if(this.dts_control.final<this.dts_control.inicio){
                toastr.warning(`La fecha de Inicio <b>NO</b> puede ser Mayor a la final`);
                return false;
            }
            return true;
        },
        async mCallTasksControl(){ 
            if(this.mValidateCallTasksControl()){
                let tasks= await axios.post(`getTasksCaptainsAll?api_token=${Vue.auth.getToken()}`, qs.stringify(this.dts_control));
                // console.log(tasks);
                this.lists_tasks_control=tasks.data;
            }
        },
        async mChargeInit(){
            this.dts_tarea.inicio=this.mObtieneDiaActual();
            this.dts_tarea.vencimiento=this.mObtieneDiaActual();
            this.dts_asignados.inicio=this.mObtieneDiaActual();
            this.dts_asignados.final=this.mObtieneDiaActual();
            this.dts_control.inicio=this.mObtieneDiaActual();
            this.dts_control.final=this.mObtieneDiaActual();
            let tareas_aux=await axios.get(`globals/task?api_token=${Vue.auth.getToken()}`);
            let origen_divisiones=await axios.get(`globals/origen_task?api_token=${Vue.auth.getToken()}`);
            this.list_tareas=tareas_aux.data;
            this.list_divisiones=origen_divisiones.data;
            let ccpp=await axios.get(`requestCapitan?api_token=${Vue.auth.getToken()}`);
            // console.log(ccpp);
            this.list_unidades=ccpp.data;
            // console.log(this.list_unidades);
        },
        handleFileUpload(event) {
            const MAXIMO_TAMANIO_BYTES = 2000000; // 1MB = 1 millón de bytes
            let temp_archivo=event.target.files[0];

            if (temp_archivo.size <= MAXIMO_TAMANIO_BYTES) {
                this.select_file = event.target.files[0];
            } else {
                const tamanioEnMb = MAXIMO_TAMANIO_BYTES / 1000000;
                toastr.warning(`El tamaño máximo es ${tamanioEnMb} MB`);
                event.target.value='';
                // Validación pasada. Envía el formulario o haz lo que tengas que hacer
            }
        },
        mValidateFormRegister(){
            if(this.dts_tarea.origen===0){
                toastr.warning("Seleccione una Unidad de Origen");
                return false;
            }
            if(this.dts_tarea.tipodoc===0){
                toastr.warning("Indique el tipo de Documento");
                return false;
            }
            if(this.dts_tarea.ruta.trim().length===0){
                toastr.warning("Indique la ruta u trazado del documento");
                return false;
            }
            if(this.dts_tarea.resumen.trim().length===0){
                toastr.warning("Debe indicar un breve resumen de lo que trata el documento");
                return false;
            }
            if(this.dts_tarea.inicio.trim().length===0){
                toastr.warning("Indique la Fecha de Registro u Emisión del Documento");
                return false;
            }
            if(this.dts_tarea.vencimiento.trim().length===0){
                toastr.warning("Indique la Fecha de Vencimiento para la presentacion del Documento");
                return false;
            }

            if(this.dts_tarea.vencimiento<this.dts_tarea.inicio){
                toastr.warning("Verifique que las fechas no esten Erroneas");
                return false;
            }

            if(this.select_file===null){
                toastr.warning("Debe seleccionar un documento PDF a enviar al servidor");
                return false;
            }
            return true;
        },
        mClearFormTask(){
            this.dts_tarea.ruta='';
        },
        async mRegisterTarea(){
            try {
            
                if(this.mValidateFormRegister()){
                    this.animacion_file=true;
                    const formData = new FormData();
                    formData.append('file', this.select_file);
                    formData.append('tipodoc', this.dts_tarea.tipodoc);
                    formData.append('divo', this.dts_tarea.origen);
                    formData.append('ruta', this.dts_tarea.ruta);
                    formData.append('resumen', this.dts_tarea.resumen);
                    formData.append('inicio', this.dts_tarea.inicio);
                    formData.append('vencimiento', this.dts_tarea.vencimiento);

                    
                    let regTarea=await axios.post(`regTaskNew?api_token=${Vue.auth.getToken()}`, formData);
                    if(regTarea.data.status){
                        toastr.success(`${regTarea.data.respuesta}`)
                    }else{
                        toastr.error(`${regTarea.data.respuesta}`)
                    }
                    setTimeout(()=>{
                        this.animacion_file=false;
                    },2000)
                }
                
            } catch (error) {
                console.log(error);
                this.animacion_file=false;
            }
                        
        }
      },
      computed:{
  
      }
  }
  </script>
  
  <style>
  
  </style>


// WEBPACK FOOTER //
// src/components/captain/NewTaskCaptain.vue